var _desc, _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 500 500)",
    id: 194702
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1.2922 -0.6394)",
    id: "rect6883"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1.0016,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-398.1426, -396.2109)",
    d: "M 66.886719 22.435547 C 43.330805 22.435547 24.367188 41.399168 24.367188 64.955078 L 24.367188 727.4668 C 24.367188 751.0227 43.330805 769.98633 66.886719 769.98633 L 400.4082 769.98633 L 729.39844 769.98633 C 752.95434 769.98633 771.91797 751.0227 771.91797 727.4668 L 771.91797 64.955078 C 771.91797 41.399168 752.95434 22.435547 729.39844 22.435547 L 400.4082 22.435547 L 66.886719 22.435547 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.7795 0 0 3.7795 1.2912 -0.6404)",
    id: "rect4500"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0.2731,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-105.3419, -104.8308)",
    d: "m 104.7715 67.305786 l -6.937758 11.368894 l -6.105241 -1.980236 l 3.113284 21.405003 l -8.985463 -11.324891 l -2.289034 5.155655 l -11.271829 -0.877588 l 2.445566 10.861697 l -5.161253 2.99435 l 13.365662 9.80865 c 0.750654 0.99148 4.744754 4.17917 5.209784 5.85671 c 0.273322 1.62783 -1.302377 4.23273 -1.302377 4.23273 l 3.01169 -0.89544 c 4.611363 -1.01195 9.51296 -1.51093 14.374719 -1.74851 v 20.19302 h 2.20529 v -20.21782 c 4.49563 0.0924 9.74636 0.99505 13.4534 1.77331 l 3.01168 0.89544 c 0 0 -1.5757 -2.6049 -1.30238 -4.23273 c 0.46503 -1.67754 4.45913 -4.86523 5.20979 -5.85671 l 7.71748 -5.66365 l 6.5695 -4.145 l -5.16126 -2.99435 l 2.44556 -10.861697 l -11.27182 0.877588 l -2.28903 -5.155655 l -10.22944 12.892326 l 3.34155 -22.972438 l -5.77191 1.871969 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -291.4539 -0.6394)",
    id: "rect4538"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-105.3965, -396.2109)",
    d: "M 66.886719 22.435547 C 43.330805 22.435547 24.367188 41.399168 24.367188 64.955078 L 24.367188 727.4668 C 24.367188 751.0227 43.330805 769.98633 66.886719 769.98633 L 186.42578 769.98633 L 186.42578 22.435547 L 66.886719 22.435547 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.7795 0 0 3.7795 294.0378 -0.6421)",
    id: "path4545"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0.5292,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-182.7976, -104.8308)",
    d: "m 192.98667 5.9360717 c 6.2325 0 11.24996 5.0174583 11.24996 11.2499593 V 192.47559 c 0 6.2325 -5.01746 11.24996 -11.24996 11.24996 H 161.35863 V 5.9360717 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanada);
export default __webpack_public_path__ + "static/media/canada.c1a9345ba923b0f55571f79f06a56282.svg";
export { ForwardRef as ReactComponent };